import { render, staticRenderFns } from "./CaptureSelfie.vue?vue&type=template&id=252edf00&scoped=true&"
import script from "./CaptureSelfie.vue?vue&type=script&lang=ts&"
export * from "./CaptureSelfie.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureSelfie.vue?vue&type=style&index=0&id=252edf00&scoped=true&lang=css&"
import style1 from "./CaptureSelfie.vue?vue&type=style&index=1&id=252edf00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252edf00",
  null
  
)

export default component.exports